module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/AFC测试设备.8c5cfccf.jpg";